module.exports = __webpack_public_path__ + "static/media/llanta-desgaste-prematuro-red.b3d4a6f9.svg";